import Button from 'antd/es/button/Button';
import { clsx } from 'clsx';
import React from 'react';

import s from './AntButton.module.less';
import { AntButtonProps } from './AntButton.types';

export const AntButton = React.forwardRef<HTMLButtonElement, AntButtonProps>((props, ref) => {
  const { noPadding, className, ...rest } = props;

  return <Button {...rest} className={clsx(className, noPadding && s.noPadding)} ref={ref} />;
});

AntButton.displayName = 'AntButton';
